var accordions = document.querySelectorAll('.trigger-accordion-container');

var openAccordion = function openAccordion(accordion) {
  var content = accordion.querySelector('.content-accordion');
  accordion.classList.add('accordion-open');
  content.style.maxHeight = content.scrollHeight + 'px';
};

var closeAccordion = function closeAccordion(accordion) {
  var content = accordion.querySelector('.content-accordion');
  accordion.classList.remove('accordion-open');
  content.style.maxHeight = null;
};

accordions.forEach(function (accordion) {
  var intro = accordion.querySelector('.trigger-accordion');
  var content = accordion.querySelector('.content-accordion');

  intro.onclick = function () {
    if (content.style.maxHeight) {
      closeAccordion(accordion);
    } else {
      accordions.forEach(function (accordion) {
        return closeAccordion(accordion);
      });
      openAccordion(accordion);
    }
  };
});